<ion-header
  data-cy="import-non-usf-product-modal-header"
  class="ion-no-border"
  [ngClass]="
    platform === platformRef.desktop
      ? 'ion-header-modal-desktop'
      : platform === platformRef.tablet
        ? 'ion-header-modal-tablet'
        : 'ion-header-modal-mobile'
  "
>
  <ion-toolbar>
    <ion-buttons slot="end">
      <ion-button
        *ngIf="platform === platformRef.desktop"
        id="close-modal-btn"
        datea-cy="close-import-non-usf-product-modal-icon"
        (click)="dismissModal()"
      >
        <ion-icon slot="icon-only" name="close-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-label [attr.data-cy]="'import-errors-title'" class="title-bold">
      {{ 'i18n.inventory.importNonUsfProdcutsModal.importErrors' | translate }}
    </ion-label>
  </ion-toolbar>
</ion-header>
<ion-content
  mode="ios"
  [ngClass]="
    platform === platformRef.desktop
      ? 'ion-content-modal-desktop'
      : platform === platformRef.tablet
        ? 'ion-content-modal-tablet'
        : 'ion-content-modal-mobile'
  "
>
  <ion-list lines="full" [attr.data-cy]="'import-errors-list'">
    <ion-item *ngFor="let error of errorList.value">
      <ion-label class="error-details ion-text-wrap">
        <span class="error-row-number">
          {{ 'i18n.inventory.importNonUsfProdcutsModal.importRow' | translate }}
          &nbsp; {{ error.rowNumber }}
        </span>
        <span class="error-message"> {{ error.message }} </span>
      </ion-label>
    </ion-item>
  </ion-list>
</ion-content>

<ion-footer class="ion-footer-modal">
  <ion-toolbar>
    <ion-buttons>
      <ion-button
        data-cy="cancel-download-non-usf-product-errors"
        [ngClass]="
          platform === platformRef.mobile
            ? 'usf-outline-green-mobile-modal-button'
            : 'usf-outline-green-dsktp-tblt-modal-button'
        "
        (click)="dismissModal()"
      >
        {{ 'i18n.common.close' | translate }}
      </ion-button>

      <ion-button
        data-cy="download-non-usf-product-errors"
        [ngClass]="
          platform === platformRef.mobile
            ? 'usf-fill-green-mobile-modal-button'
            : 'usf-fill-green-dsktp-tblt-modal-button'
        "
        (click)="downloadErrors()"
      >
        {{ 'i18n.common.download' | translate }}
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-footer>
